import { render, staticRenderFns } from "./StoreClosure.vue?vue&type=template&id=1a647350&scoped=true&"
import script from "./StoreClosure.vue?vue&type=script&lang=ts&"
export * from "./StoreClosure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a647350",
  null
  
)

export default component.exports